import { render, staticRenderFns } from "./PrintNewLabel.vue?vue&type=template&id=02842a0b&scoped=true&"
import script from "./PrintNewLabel.vue?vue&type=script&lang=js&"
export * from "./PrintNewLabel.vue?vue&type=script&lang=js&"
import style0 from "./PrintNewLabel.vue?vue&type=style&index=0&id=02842a0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02842a0b",
  null
  
)

export default component.exports